import { ModalConfig, useModal } from '@shape-ds/components';
import '../style.scss';
import { usePreventLeaveModal } from 'hooks/usePreventEditLeave/usePreventEditLeave';
import EventDetails from '../components/EventDetails/EventDetails';
import { EventItem } from 'queries/events/types';

const useEventModal = () => {
  const { openModal, closeAll } = useModal();
  const { openLeaveModal } = usePreventLeaveModal();

  return {
    openEventModal: (data: EventItem, config?: ModalConfig) => {
      openModal(<EventDetails selectedRow={data} assetId={data.asset.id} />, {
        ...config,
        className: 'events events-modal',
        PaperProps: { style: {}, className: 'events-modal-paper' },
        shouldPreventLeave: () => {
          const url = new URL(window.location.href);
          return url.searchParams.has('edit');
        },
        onPreventLeave: () => {
          openLeaveModal(closeAll);
        },
      });
    },
  };
};

export default useEventModal;
